import Vue from 'vue';
import axios from 'axios';
import { AccessTokenKey } from '@/store/auth/auth.store.constants';

const axiosParams = {
  baseURL: process.env.VUE_APP_API_NODE,
  withCredentials: true, // Enable sending cookies with requests
};
const axiosBackend = axios.create(axiosParams);

function isValidJWT(token) {
  if (!token) return false;
  const parts = token.split('.');
  return parts.length === 3 && parts.every(part => part && part.length > 0);
}

axiosBackend.interceptors.request.use((config) => {
  // Get token directly without splitting
  const token = Vue.$cookies.get(AccessTokenKey);
  
  if (token) {
    if (isValidJWT(token)) {
      config.headers.Authorization = `Bearer ${token}`;
      // console.debug('Valid JWT token found and set in headers');
    } else {
      console.warn('Invalid JWT token format:', token.substring(0, 20) + '...');
    }
  } else {
    console.warn('No token found in cookies');
  }

  // Add CSRF token if available
  const csrfToken = Vue.$cookies.get('XSRF-TOKEN');
  if (csrfToken) {
    config.headers['X-XSRF-TOKEN'] = csrfToken;
  }

  // Ensure cookies are included in the request
  config.withCredentials = true;

  return config;
}, (error) => Promise.reject(error));

export default axiosBackend;
